import { promotionAndCouponRoutes, promotionRoutes, agentRoutes, transactionsRoutes, shopRoutes, constantRouterMap, bankingSolutions } from '@/utils/routes'

export function menu(globalMenu) {
  let routes = constantRouterMap
  if (globalMenu['isCouponEnabled']) {
    routes = routes.concat(promotionAndCouponRoutes)
  } else {
    routes = routes.concat(promotionRoutes)
  }

  routes = routes.concat(transactionsRoutes)

  if (globalMenu['isAgencyEnabled']) {
    routes = routes.concat(agentRoutes)
  }
  routes = routes.concat(bankingSolutions)

  routes = routes.concat(shopRoutes)
  return routes
}
